<template>
  <div>
    <div class="content-header">
      <div class="left">
         <span class="title">充值活动</span>
      </div>
      <div class="right">
        <Button type="primary"  @click="openModal(false)">新增充值活动</Button>
      </div>
    </div>
    <div>
      <Table :columns="columns" :data="list" :loading="tableLoading"/>
    </div>
    <div class="t-right">
      <Page
        @on-change="pageChange"
        @on-page-size-change="sizeChange"
        :total="total"
        show-elevator
        show-sizer
        show-total
      />
    </div>
    <Modal v-model="visible" title="充值活动" width="1200">
      <Form ref="formInline" :model="current" :rules="rule" :label-width="100" inline>
        <div>
          <FormItem prop="name" label="名称:">
            <Input v-model="activity.name" style="width:120px" placeholder="活动名称"/>
          </FormItem>
          <FormItem prop="start_day" label="开始时间:">
            <DatePicker
              :value="activity.start_date"
              format="yyyy-MM-dd"
              type="date"
              placement="bottom-end"
              placeholder="选择日期"
              style="width: 120px;margin: 0 0 0 5px;"
              :confirm="false"
              :clearable="false"
              :editable="false"
              :options="start_options"
              @on-change="handleOk"
            ></DatePicker>
            <TimePicker v-model="activity.start_time" format="HH:mm" placeholder="选择时间" style="width: 112px;margin-left: 5px"></TimePicker>
          </FormItem>
          <FormItem prop="end_day" label="结束时间:">
            <DatePicker
              :value="activity.end_date"
              format="yyyy-MM-dd"
              type="date"
              placement="bottom-end"
              placeholder="选择日期"
              style="width: 120px;margin: 0 0 0 5px;"
              :confirm="false"
              :clearable="false"
              :editable="false"
              :options="end_options"
              @on-change="handleOk1"
            ></DatePicker>
            <TimePicker v-model="activity.end_time" format="HH:mm" placeholder="选择时间" style="width: 112px;margin-left: 5px"></TimePicker>
          </FormItem>
          <br/>
          <FormItem prop="describe" label="描述:">
            <Input v-model="activity.note" style="width:120px" placeholder="活动描述"/>
          </FormItem>
          <FormItem prop="describe" label="活动码:">
            <Input v-model="activity.code" style="width:120px" placeholder="输入4位活动码"/>
          </FormItem>
        </div>
        <div class="activity" v-for="(item,key) in activity.vals" :key="key">
          <FormItem prop="name" label="充值金额:">
            <label style="width:120px;display: block">{{item.title}}元</label>
          </FormItem>
          <FormItem prop="describe" label="优惠券:">
            <!--<Input v-model="item.cid" style="width:120px" placeholder="选择赠送优惠券"/>-->
            <Select v-model="item.cid" style="width:200px">
              <Option v-for="(v,k) in data" :value="v.id" :key="k">{{v.name}}</Option>
            </Select>
          </FormItem>
          <FormItem prop="describe" label="数量:">
            <Input v-model="item.num" style="width:120px" placeholder="输入数量"/>
          </FormItem>
          <FormItem prop="describe" label="金额:">
            <Input v-model="item.value" style="width:150px" placeholder="输入赠送金额（角标）"/> 元
          </FormItem>
        </div>
      </Form>
      <div slot="footer">
        <Button size="large" @click="visible = false;">取消</Button>
        <Button type="primary" size="large" @click="modalOk" :loading="modalLoading">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  data () {
    return {
      start_options: {
        disabledDate (date) {
          return date && date.valueOf() < Date.now() - 86400000
        }
      }, // 开始时间
      end_options: {
        disabledDate (date) {
          return date && date.valueOf() < Date.now() - 86400000
        }
      }, // 结束时间
      data: [],
      list: [],
      page: {
        p: 0,
        l: 10
      },
      total: 0,
      columns: [
        { title: '编号', key: 'id' },
        { title: '活动名称', key: 'name' },
        { title: '活动描述', key: 'note' },
        { title: '活动码', key: 'code' },
        {
          title: '开始时间',
          key: 'start_date',
          render: (h, data) => {
            return h('span', {}, this.$momentDate(data.row.start_date))
          }
        },
        {
          title: '结束时间',
          key: 'end_date',
          render: (h, data) => {
            return h('span', {}, this.$momentDate(data.row.end_date))
          }
        },
        {
          title: '操作',
          key: 'operate',
          render: (h, data) => {
            return h('div', {}, [
              h(
                'Button',
                {
                  props: {
                    size: 'small',
                    type: data.row.is_del ? 'success' : 'error'
                  },
                  on: {
                    click: () => {
                      this.delActivity(data.row.id, data.row.is_del)
                    }
                  }
                },
                data.row.is_del ? '恢复' : '删除'
              ),
              h(
                'Button',
                {
                  props: { size: 'small', type: 'warning' },
                  style: { marginLeft: '5px' },
                  on: {
                    click: () => {
                      this.openModal(JSON.parse(JSON.stringify(data.row)))
                    }
                  }
                },
                '修改'
              )
            ])
          }
        }
      ],
      tableLoading: false,
      modalLoading: false,
      visible: false,
      current: {},
      rule: {
        over_day: [
          {
            validator: (rule, value, callback) => {
              if (parseInt(value) == value && parseInt(value) > 0) {
                callback()
              } else {
                callback(new Error('请输入大于零正整数'))
              }
            },
            required: true,
            trigger: 'blur'
          }
        ]
      },
      activity: {
        id: 0,
        name: '',
        note: '',
        start_date: '',
        start_time: '00:00',
        end_date: '',
        end_time: '00:00',
        code: '',
        vals: [
          {
            title: '100',
            value: '',
            num: 0,
            cid: 0
          },
          {
            title: '50',
            value: '',
            num: 0,
            cid: 0
          },
          {
            title: '30',
            value: '',
            num: 0,
            cid: 0
          },
          {
            title: '20',
            value: '',
            num: 0,
            cid: 0
          },
          {
            title: '10',
            value: '',
            num: 0,
            cid: 0
          }
        ]
      }
    }
  },
  methods: {
    delActivity (id, is_del) {
      let data = {
        id,
        is_del: is_del ? 0 : 1
      }
      this.AddRechargeActivity(data).then(res => {
        if (res.code != 1) {
          this.$Message.error('操作失败')
          return false
        }
        this.$Message.success('操作成功')
        this.getList()
      })
    },
    openModal (data) {
      this.$refs.formInline.resetFields()
      this.visible = true
      if (data) this.activity = data
    },
    getData () {
      this.getCouponAll().then(res => {
        this.data = res.data
        this.total = res.total
        this.tableLoading = false
      })
    },
    getList () {
      this.GetRechargeActivity(this.page).then(res => {
        res.data.map(item => {
          item.start_time = this.$moment(new Date(item.start_date), 'HH:mm')
          item.end_time = this.$moment(new Date(item.end_date), 'HH:mm')
          item.start_date = this.$moment(new Date(item.start_date), 'YYYY-MM-DD')
          item.end_date = this.$moment(new Date(item.end_date), 'YYYY-MM-DD')
        })
        this.total = res.total
        this.tableLoading = false
        this.list = res.data
      })
    },
    sizeChange (l) {
      this.page.l = l
      this.getList()
    },
    pageChange (p) {
      this.page.p = p - 1
      this.getList()
    },
    modalOk () {
      let data = JSON.parse(JSON.stringify(this.activity))
      delete data._index
      delete data._rowKey
      console.log(282, data)
      // 验证表单
      if (!data.name) {
        this.$Message.error('请输入活动名称')
        return
      }
      if (!data.note) {
        this.$Message.error('请输入活动备注')
        return
      }
      if (!data.start_date) {
        this.$Message.error('请选择开始时间')
        return
      }
      if (!data.code) {
        this.$Message.error('请输入活动码')
        return
      }
      if (data.code.length !== 4) {
        this.$Message.error('活动码长度错误')
        return
      }
      let flag = true
      data.vals.map((item, index) => {
        if (!item.cid) {
          flag = 0
          return
        }
        if (!item.num) {
          flag = 1
          return
        }
        if (!item.value) {
          flag = 2
        }
      })
      if (flag === 0) {
        this.$Message.error('请选择优惠券')
        return
      }
      if (flag === 1) {
        this.$Message.error('请输入数量')
        return
      }
      if (flag === 2) {
        this.$Message.error('请输入金额')
        return
      }
      data.start_date = `${data.start_date} ${data.start_time}`
      data.end_date = `${data.end_date} ${data.end_time}`
      if (new Date(data.start_date).getTime() >= new Date(data.end_date).getTime()) {
        this.$Message.error('操作失败,开始时间不得大于结束时间')
        return
      }
      delete data.start_time
      delete data.end_time
      this.AddRechargeActivity(data).then(res => {
        if (!res.status) {
          this.$Message.error(res.msg)
          return false
        }
        this.$Message.success(res.msg)
        this.modalLoading = false
        this.visible = false
        this.getList()
      })
    },
    handleOk (date) {
      console.log(date)
      this.activity.start_date = date
    },
    handleOk1 (date) {
      this.activity.end_date = date
    },
    ...mapActions([
      'getCouponAll',
      'AddRechargeActivity',
      'GetRechargeActivity'
    ])
  },
  mounted () {
    this.getData()
    this.getList()
  },
  computed: mapGetters({})
}
</script>

<style lang="less" scoped>
@import "./index.less";
</style>
